import { render, staticRenderFns } from "./simpleSmallerThan.vue?vue&type=template&id=935cb554&"
import script from "./simpleSmallerThan.vue?vue&type=script&lang=ts&"
export * from "./simpleSmallerThan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports